import {
  CONSULTANT_SPECIALITY_LIST_REQUEST,
  CONSULTANT_SPECIALITY_LIST_RECEIVED,
  CONSULTANT_SPECIALITY_LIST_ERROR,
  CONSULTANT_SPECIALITY_SINGLE_CREATE_REQUEST,
  CONSULTANT_SPECIALITY_SINGLE_CREATE_SUCCESS,
} from '../constants';

const reducer = (
  state = {
    consultantSpecialities: [],
    isFetchingConsultantSpecialities: false,
    isCreatingConsultantSpeciality: false,
  },
  action,
) => {
  switch (action.type) {
    case CONSULTANT_SPECIALITY_LIST_REQUEST:
      return {
        ...state,
        isFetchingConsultantSpecialities: true,
      };

    case CONSULTANT_SPECIALITY_LIST_RECEIVED:
      return {
        ...state,
        consultantSpecialities: action.data['hydra:member'],
        isFetchingConsultantSpecialities: false,
      };

    case CONSULTANT_SPECIALITY_LIST_ERROR:
      return {
        ...state,
        isFetchingConsultantSpecialities: false,
      };

    case CONSULTANT_SPECIALITY_SINGLE_CREATE_REQUEST:
      return {
        ...state,
        isCreatingConsultantSpeciality: true,
      };

    case CONSULTANT_SPECIALITY_SINGLE_CREATE_SUCCESS:
      return {
        ...state,
        isCreatingConsultantSpeciality: false,
        consultantSpecialities: [...state.consultantSpecialities, action.data],
      };

    default:
      return state;
  }
};

export default reducer;
